<template>
  <div>
    <div class="tracking-permission-state debug-stats">
      <span>tracking permission state (not saved)</span>
      consentDate: {{ state.services }}<br />
    </div>

    <div
      v-if="cookie.requiredCookies"
      class="tracking-permission-cookie debug-stats"
    >
      <span>tracking permission cookie (saved)</span>
      consentDate: {{ state.services }}<br />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  // props
  props: ['state', 'cookie'],

  // data
  data() {
    return {}
  },

  // computed
  computed: {},

  // mounted
  mounted() {},

  // methods
  methods: {},
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
</style>
